import React, { useMemo } from 'react';
import Select from '@/common/components/Inputs/Select/index';
import { useLocalizedField } from '@/common/hooks/index';
import Autocomplete from '@/common/components/Inputs/Autocomplete/index';
import { useGeneralMetaDataQuery } from '@/entities/meta-data';

const AUTOCOMPLETE_SELECTS = [
  'DD_FIREARM_TYPE',
  'DD_CREDIT_CARDS',
  'DD_PROV',
  'DD_COUNTRY',
  'DD_INSURANCE',
  'DD_CELL_PHONE',
  'DD_SOCIAL_MEDIA',
  'DD_EMAIL',
  'DD_PROV_TERR',
  'DD_COUNTRY',
];
const SelectMeta = ({ metaName = '', ...props }) => {
  const { data: metaData = {} } = useGeneralMetaDataQuery();
  const { dropdowns } = metaData;
  const getLocalizedField = useLocalizedField();

  const options = useMemo(() => {
    if (!dropdowns) return [];
    return getLocalizedField(dropdowns, metaName);
  }, [dropdowns, getLocalizedField, metaName]);

  return AUTOCOMPLETE_SELECTS.includes(metaName) ? (
    <Autocomplete options={options} {...props} />
  ) : (
    <Select options={options} {...props} />
  );
};

export default SelectMeta;
